import { defineMessages } from 'react-intl';

export const messages: {
	collapseSidebar: { defaultMessage: string; description: string; id: string };
	conversationAssistant: { defaultMessage: string; description: string; id: string };
	editionAwareness: { defaultMessage: string; description: string; id: string };
	expandSidebar: { defaultMessage: string; description: string; id: string };
	help: { defaultMessage: string; description: string; id: string };
	logo: { defaultMessage: string; description: string; id: string };
	notifications: { defaultMessage: string; description: string; id: string };
	profile: { defaultMessage: string; description: string; id: string };
	search: { defaultMessage: string; description: string; id: string };
	settings: { defaultMessage: string; description: string; id: string };
	universalCreate: { defaultMessage: string; description: string; id: string };
} = defineMessages({
	collapseSidebar: {
		defaultMessage: 'Collapse sidebar',
		description: 'Label for the button that collapses the sidebar navigation.',
		id: 'global-root.global-root.collapseSidebar',
	},
	conversationAssistant: {
		defaultMessage: 'Conversation Assistant',
		description: 'Placeholder label for the conversation assistant slot in the top navigation bar.',
		id: 'global-root.global-root.conversationAssistant',
	},
	editionAwareness: {
		defaultMessage: 'Edition awareness',
		description: 'Placeholder label for the edition awareness slot in the top navigation bar.',
		id: 'global-root.global-root.editionAwareness',
	},
	expandSidebar: {
		defaultMessage: 'Expand sidebar',
		description: 'Label for the button that expands the sidebar navigation.',
		id: 'global-root.global-root.expandSidebar',
	},
	help: {
		defaultMessage: 'Help',
		description: 'Label for the help button in the top navigation bar.',
		id: 'global-root.global-root.help',
	},
	logo: {
		defaultMessage: 'Logo',
		description: 'Placeholder label for the logo slot in the top navigation bar.',
		id: 'global-root.global-root.logo',
	},
	notifications: {
		defaultMessage: 'Notifications',
		description: 'Placeholder label for the notifications slot in the top navigation bar.',
		id: 'global-root.global-root.notifications',
	},
	profile: {
		defaultMessage: 'Profile',
		description: 'Placeholder label for the profile slot in the top navigation bar.',
		id: 'global-root.global-root.profile',
	},
	search: {
		defaultMessage: 'Search',
		description: 'Placeholder label for the search slot in the top navigation bar.',
		id: 'global-root.global-root.search',
	},
	settings: {
		defaultMessage: 'Settings',
		description: 'Placeholder label for the settings slot in the top navigation bar.',
		id: 'global-root.global-root.settings',
	},
	universalCreate: {
		defaultMessage: 'Universal Create',
		description: 'Placeholder label for the universal create slot in the top navigation bar.',
		id: 'global-root.global-root.universalCreate',
	},
});
